import axios from '../api' // 倒入 api
export const company = {
  // 取消企业认证
  cancelApprove: data => {
    return axios({
      url: '/huizb-app/approve/cancelApprove',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 企业信息
  orgInfo: data => {
    return axios({
      url: '/huizb-app/orgContent/orgInfo',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 企业信息
  selectOrgInfo: data => {
    return axios({
      url: '/huizb-app/orgSearchTYC/selectOrgInfo',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 企业变更信息
  orgChangeList: data => {
    return axios({
      url: '/huizb-app/orgSearchTYC/selectOrgChange',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 企业年报
  selectYearReportByOrgNo: params => {
    return axios({
      url: '/huizb-app/orgContent/selectYearReportByOrgNo',
      method: 'get',
      base: 'ZBID',
      hideMsg: true,
      params
    })
  },
  // 企业年报详情
  selectOneByOrgNo: data => {
    return axios({
      url: '/huizb-app/orgContent/selectOneByOrgNo',
      method: 'post',
      base: 'ZBID',
      loading: true,
      data
    })
  },
  // 企业资质 
  getOrgApititudelist: data => {
    return axios({
      url: '/huizb-app/orgQuaCert/getOrgApititudelist',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 知识产权（注册商标）
  getHuiCoreOpenApiEquityBrandlist: data => {
    return axios({
      url: '/huizb-app/orgQuaCert/getHuiCoreOpenApiEquityBrandlist',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 软件著作权
  getHuiCoreOpenApiEquitySoftlist: data => {
    return axios({
      url: '/huizb-app/orgQuaCert/getHuiCoreOpenApiEquitySoftlist',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 企业资质（作品著作权）
  getHuiCoreOpenApiEquityWorklist: data => {
    return axios({
      url: '/huizb-app/orgQuaCert/getHuiCoreOpenApiEquityWorklist',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 知识产权（发明专利）
  getHuiCoreOpenApiEquityInventionlist: data => {
    return axios({
      url: '/huizb-app/orgQuaCert/getHuiCoreOpenApiEquityInventionlist',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 企业注册类证书
  getOrgRegisterCertlist: data => {
    return axios({
      url: '/huizb-app/orgQuaCert/getOrgRegisterCertlist',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 纳税信用等级
  getOrgTaxCreditRatingPageByKey: data => {
    return axios({
      url: '/huizb-app/orgQuaCert/getOrgTaxCreditRatingPageByKey',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 招标采购数量
  getProjectBidSectionByOrgNo: data => {
    return axios({
      url: '/huizb-app/appBidInfo/getProjectBidSectionByOrgNo',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 招标采购数量详情
  getTenderInfoList: data => {
    return axios({
      url: '/huizb-app/appTracker/getTenderInfoList',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      loading: true,
      data
    })
  },
  // 行业协会荣誉
  orgHonestyList: data => {
    return axios({
      url: '/huizb-app/orgHonesty/list',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 行业协会荣誉
  orgHonestyInfo: data => {
    return axios({
      url: '/huizb-app/orgHonesty/info',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      loading: true,
      data
    })
  },
  // 自律公约签署
  getAssOrgRelation: data => {
    return axios({
      url: '/huizb-app/appOrg/getAssOrgRelation',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 获取企业诚信评价列表
  selectOrgCxCommendCx: data => {
    return axios({
      url: '/huizb-app/orgContent/selectOrgCxCommendCx',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 获取企业不良行为记录列表
  orgCxBadBehaviorList: data => {
    return axios({
      url: '/huizb-app/orgCxBadBehavior/list',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 获取企业不良行为记录详情
  orgCxBadBehaviorInfo: data => {
    return axios({
      url: '/huizb-app/orgCxBadBehavior/info',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      loading: true,
      data
    })
  },
  // 履约失信
  selectOrgCxCommendSx: data => {
    return axios({
      url: '/huizb-app/orgContent/selectOrgCxCommendSx',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 其他失信
  selectOrgElseInfo: data => {
    return axios({
      url: '/huizb-app/orgContent/selectOrgElseInfo',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 企业基础评价信息
  selectBaseDetail: params => {
    return axios({
      url: '/huizb-app/orgContent/selectBaseDetail',
      method: 'get',
      base: 'ZBID',
      hideMsg: true,
      params
    })
  },
  // 企业征信
  selectCreditInfo: params => {
    return axios({
      url: '/huizb-app/orgContent/selectCreditInfo',
      method: 'get',
      base: 'ZBID',
      hideMsg: true,
      params
    })
  },
  // 企业征信详情
  getlistbypage: data => {
    return axios({
      url: '/hui-xypt/cxFile/getlistbypage',
      method: 'post',
      base: 'BASE',
      hideMsg: true,
      loading: true,
      data
    })
  },
  // 股东信息
  selectOrgShareHolderListInfo: data => {
    return axios({
      url: '/huizb-app/orgSearchTYC/selectOrgShareHolderListInfo',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 企业征信详情
  getlistbypage: data => {
    return axios({
      url: '/hui-xypt/cxFile/getlistbypage',
      method: 'post',
      base: 'BASE',
      hideMsg: true,
      data
    })
  },
}
export default company